import { Component, ViewChild } from '@angular/core';

import { AlertController, App, ItemSliding, List, ModalController, NavController } from 'ionic-angular';

import {InAppBrowser} from 'ionic-native';

import { JobInfo } from '../job-info/job-info';

import { UserData } from '../../providers/user-data';

import { Http } from '@angular/http';

import 'rxjs/add/operator/map';



@Component({
  templateUrl: 'build/pages/invoice/invoice.html'
})


export class Invoice {


 

        jobs: Array<any>;

 username: string;


  constructor(
    public alertCtrl: AlertController,
    public app: App,
    public modalCtrl: ModalController,
    public navCtrl: NavController,
    public user: UserData,
    private http: Http
  ) {
this. loadjobs();

  }



 launch() {

 var url = 'http://letpco.co.uk/api/v1/pay?authkey='+this.username;
let browser = new InAppBrowser(url, '_blank');
    }




  loadjobs() {



  this.user.getUsername().then((username) => {
    this.username = username;
 var url = 'http://letpco.co.uk/api/v1/invoice?authkey='+this.username;

          this.http.get(url).subscribe(res => {

 document.getElementById('desc').innerHTML = '<h1 class="center">' +  res.json().data.toUpperCase()  +' : £'+ res.json().value + '</h1>' ;
      });


  });
    }


   


 
}
